import { useEffect, useRef, useState } from "react";
import { DateRange, PeriodOption } from "../ui/DateRangeSelector/types";

/**
 * Manages a local period selection that initializes from a parent period
 * whenever the trigger value changes, then allows independent divergence.
 */
export function useCascadingPeriod(
  parentPeriod: PeriodOption,
  parentCustomDateRange: DateRange | undefined,
  trigger: unknown,
) {
  const [period, setPeriod] = useState(parentPeriod);
  const [customDateRange, setCustomDateRange] = useState(parentCustomDateRange);

  const parentPeriodRef = useRef(parentPeriod);
  parentPeriodRef.current = parentPeriod;

  const parentCustomDateRangeRef = useRef(parentCustomDateRange);
  parentCustomDateRangeRef.current = parentCustomDateRange;

  useEffect(() => {
    if (trigger != null) {
      setPeriod(parentPeriodRef.current);
      setCustomDateRange(parentCustomDateRangeRef.current);
    }
  }, [trigger]);

  return { period, customDateRange, setPeriod, setCustomDateRange };
}
